import type { DayPickerLocale } from 'react-day-picker';
import { de, enUS, es, fr, pt } from 'react-day-picker/locale';

/**
 * Map app locale (e.g. from useIntl().locale) to a react-day-picker locale
 * for month/weekday labels in the calendar.
 * Cast needed because react-day-picker/locale also re-exports date-fns Locale types.
 */
const LOCALE_MAP: Record<string, DayPickerLocale> = {
  en: enUS as DayPickerLocale,
  es: es as DayPickerLocale,
  fr: fr as DayPickerLocale,
  pt: pt as DayPickerLocale,
  de: de as DayPickerLocale,
};

/**
 * Returns the DayPicker locale for the given app locale string (e.g. 'es-AR', 'en', 'fr').
 * Uses the first two characters to match; falls back to enUS if unknown.
 */
export function getDayPickerLocale(appLocale: string): DayPickerLocale {
  const lang = appLocale.substring(0, 2).toLowerCase();
  return LOCALE_MAP[lang] ?? enUS;
}
